import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from '@dixa/lib-shared-habla';
export function EmptyRow() {
    return (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: 3 }, { children: "No widgets found." })) }));
}
